import FuseAnimate from "@fuse/core/FuseAnimate";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon";
import { makeStyles } from "@mui/styles";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import moment from "moment";
import React, { useCallback, useEffect, useRef } from "react";
import { useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
// import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
// import second from 'react-big-calendar'
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import * as ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import CalendarHeader from "./CalendarHeader";
import EventDialog from "./EventDialog";
import HolidaysList from "./HolidaysList";
import SearchHoliday from "./SearchHoliday";
import * as Actions from "./store/actions";
import reducer from "./store/reducers";
import * as Flags from "country-flag-icons/react/3x2";
import countryList from "react-select-country-list";
import "./Calendar.css";
import Confirmation from "./Confirmation";
import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
  Typography,
} from "@mui/material";
import NetworkWifi3BarIcon from "@mui/icons-material/NetworkWifi3Bar";
import { Box, color } from "@mui/system";
import Year from "./Year";

moment.locale("ko", {
  week: {
    dow: 1,
    doy: 1,
  },
});

const localizer = momentLocalizer(moment);

// const DragAndDropCalendar = withDragAndDrop(Calendar);

const allViews = Object.keys(Views).map((k) => Views[k]);

const useStyles = makeStyles((theme) => ({
  root: {
    borderRight: `1px solid rgba(241,245,249,.12)`,

    "& .rbc-header": {
      padding: "12px 6px",
      fontWeight: 600,
      fontSize: 14,
    },
    "& .rbc-label": {
      padding: "8px 6px",
    },
    "& .rbc-today": {
      backgroundColor: "transparent",
    },
    "& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today": {
      borderBottom: `2px solid ${theme.palette.secondary.main}!important`,
      background: `${theme.palette.secondary.main}`,
    },
    "& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view": {
      padding: 24,
      [theme.breakpoints.down("sm")]: {
        padding: 16,
      },
      ...theme.mixins.border(0),
    },
    "& .rbc-agenda-view table": {
      ...theme.mixins.border(1),
      "& thead > tr > th": {
        ...theme.mixins.borderBottom(0),
      },
      "& tbody > tr > td": {
        padding: "12px 6px",
        "& + td": {
          ...theme.mixins.borderLeft(1),
        },
      },
    },
    "& .rbc-time-view": {
      "& .rbc-time-header": {
        ...theme.mixins.border(1),
      },
      "& .rbc-time-content": {
        flex: "0 1 auto",
        ...theme.mixins.border(1),
      },
    },
    "& .rbc-month-view": {
      "& > .rbc-row": {
        ...theme.mixins.border(1),
      },
      "& .rbc-month-row": {
        ...theme.mixins.border(1),
        borderWidth: "0 1px 1px 1px!important",
        minHeight: 90,
      },
      "& .rbc-header + .rbc-header": {
        ...theme.mixins.borderLeft(1),
      },
      "& .rbc-header": {
        ...theme.mixins.borderBottom(0),
      },
      "& .rbc-day-bg + .rbc-day-bg": {
        ...theme.mixins.borderLeft(1),
      },
      "& .saturday": {
        background: `#2b3138`,
      },
      "& .sunday": {
        background: `#2b3138`,
      },
    },
    "& .rbc-day-slot .rbc-time-slot": {
      ...theme.mixins.borderTop(1),
      opacity: 0.5,
    },
    "& .rbc-time-header > .rbc-row > * + *": {
      ...theme.mixins.borderLeft(1),
    },
    "& .rbc-time-content > * + * > *": {
      ...theme.mixins.borderLeft(1),
    },
    "& .rbc-day-bg + .rbc-day-bg": {
      ...theme.mixins.borderLeft(1),
    },
    "& .rbc-time-header > .rbc-row:first-child": {
      ...theme.mixins.borderBottom(1),
    },
    "& .rbc-timeslot-group": {
      minHeight: 64,
      ...theme.mixins.borderBottom(1),
    },
    "& .rbc-date-cell": {
      padding: 8,
      fontSize: 16,
      fontWeight: 400,
      opacity: 0.5,
      "& > a": {
        color: "inherit",
      },
    },
    "& .rbc-event": {
      borderRadius: 4,
      padding: "4px 8px",
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      boxShadow: theme.shadows[0],
      transitionProperty: "box-shadow",
      transitionDuration: theme.transitions.duration.short,
      transitionTimingFunction: theme.transitions.easing.easeInOut,
      position: "relative",
      "&:hover": {
        boxShadow: theme.shadows[2],
      },
    },
    "& .rbc-row-segment": {
      padding: "0 4px 4px 4px",
    },
    "& .rbc-off-range-bg": {
      backgroundColor:
        theme.palette.type === "light"
          ? "rgba(0,0,0,0.03)"
          : "rgba(0,0,0,0.16)",
    },
    "& .rbc-show-more": {
      color: theme.palette.secondary.main,
      background: "transparent",
    },
    "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event": {
      position: "static",
    },
    "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child":
      {
        left: 0,
        top: 0,
        bottom: 0,
        height: "auto",
      },
    "& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child":
      {
        right: 0,
        top: 0,
        bottom: 0,
        height: "auto",
      },
  },
  addButton: {
    position: "absolute",
    right: 30,
    top: 80,
    zIndex: 99,
  },
}));
const titleOptions = [
  { value: "Custom Event", label: "Custom Event" },
  { value: "New Year’s Day", label: "New Year’s Day" },
  { value: "Eid al Fitr", label: "Eid al Fitr" },
  { value: "Arafat Day", label: "Arafat Day" },
  { value: "Eid al Adha", label: "Eid al Adha" },
  { value: "Islamic New Year", label: "Islamic New Year" },
  {
    value: "The Prophet Muhammad’s (PBUH) birthday",
    label: "The Prophet Muhammad’s (PBUH) birthday",
  },
  { value: "Commemoration Day", label: "Commemoration Day" },
  { value: "National Day", label: "National Day" },
];
const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.holidays}`;

function CalendarMain(props) {
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [view, setView] = useState(Views.MONTH);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  // const events = useSelector(({ calendarApp }) => calendarApp.events.entities);
  const [date, setDate] = useState(new Date());
  const classes = useStyles(props);
  const headerEl = useRef(null);

  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    code: "AE",
  });
  const [selectedYear, setSelectedYear] = useState({
    value: new Date().getFullYear(),
  });

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
	if (error === 'Network Error' || error === "Service Unavailable" || error === "Request failed with status code 503") {
		setOpen(true)
	}
}, [error]);

  useEffect(() => {
    const country = async () => {
      const options = countryList().getData();
      const result = options?.map((option) => {
        const Flag = Flags[option.value];
        return {
          label: option?.label,
          value: option?.label,
          code: option?.value,
          icon: option?.value && (
            <Flag width={18} style={{ marginInline: "5px" }} />
          ),
        };
      });
      setCountryOptions(result);
      setSelectedCountry(
        result.find((item) => item.value == "United Arab Emirates")
      );
    };
    country();
  }, []);
  const changeHandler = (data) => {
    setSelectedCountry(data);
    searchData(data, selectedYear);
  };
  const changeYear = (data) => {
    const m = moment(date).month();
    setDate(new Date(data.value, m));
    setSelectedYear(data);
    searchData(selectedCountry, data);
  };

  const searchData = async (country = selectedCountry, year = selectedYear) => {
    try {
      const res = await OAuthService.getList(
        url +
          `/search/findByYearAndCountry?year=${year.value}&country=${country.code}`
      );
      const searchHoliday = res.data._embedded.holidays?.map((item) => {
		  const time = "18:00"
		const startDate = moment(item.holidayStartDate + ' ' + time)
		const endDate = moment(item.holidayEndDate + ' ' + time)
		return ({
        id: item.id,
        title: item.title,
        allDay: true,
        start: startDate,
        end: endDate,
        desc: item.description,
        country: item.country,
      })});
      setEvents(searchHoliday);
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    // loadData()
    searchData();
  }, []);

  const dayPropGetter = useCallback(
    (date) => ({
      ...(moment(date).day() === 6 && {
        className: "saturday",
      }),
      ...(moment(date).day() === 0 && {
        className: "sunday",
      }),
    }),
    []
  );

  return (
    <>
      {(error === "Network Error" || error === "Service Unavailable" || error === "Request failed with status code 503") ? (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent
              sx={{ width: "600px", height: "auto", alignItems: "center" }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NetworkWifi3BarIcon
                  sx={{ height: "100px", width: "100px", color: "#ffc107" }}
                />
              </Box>
              <DialogContentText id="alert-dialog-description" align="center">
                <Typography variant="h5">
                  Please try after some time. Server is under maintenance.
                </Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} autoFocus>
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <>
          {error && (
            <Alert severity="error" className="mb-16">
              <AlertTitle>Error</AlertTitle>
              {error}
            </Alert>
          )}
        </>
      )}
      <div className="flex flex-row overflow-scroll">
        <div className={clsx(classes.root, "flex flex-col flex-auto relative")}>
          <div ref={headerEl} />
          <SearchHoliday
            countryOptions={countryOptions}
            selectedCountry={selectedCountry}
            changeHandler={changeHandler}
            changeYear={changeYear}
            selectedYear={selectedYear}
          />
          <Calendar
            className="flex flex-1 container"
            disabled={error}
            selectable
            localizer={localizer}
            events={events}
            resizable
            view={view}
            onView={setView}
            setView={setView}
            date={date}
            onNavigate={setDate}
            // defaultDate={new Date()}
            startAccessor="start"
            endAccessor="end"
            views={{
              day: true,
              week: true,
              month: true,
              year: Year
            }}
            setDate={setDate}
            min={new Date()}
            step={60}
            showMultiDayTimes
            dayPropGetter={dayPropGetter}
            components={{
              toolbar: (_props) => {
                return headerEl.current
                  ? ReactDOM.createPortal(
                      <CalendarHeader changeYear={changeYear} {..._props} />,
                      headerEl.current
                    )
                  : null;
              },
            }}
            // onNavigate={handleNavigate}
            onSelectEvent={(event) => {
              dispatch(Actions.openEditEventDialog(event));
            }}
            onSelectSlot={(slotInfo) => {
				if (moment(slotInfo.start).isBefore(moment(), 'day')) {
					return;
				  }
              const end = slotInfo.end;
              end.setDate(slotInfo.end.getDate() - 1);
              dispatch(
                Actions.openNewEventDialog({
                  start: slotInfo.start,
                  end: end,
                })
              );
            }}
          />
          <FuseAnimate animation="transition.expandIn" delay={500}>
		  <Tooltip title={"Add Holiday/Event"}>
            <Fab
              color="primary"
              variant="outlined"
              aria-label="add"
              className={classes.addButton}
              onClick={() =>
                dispatch(
                  Actions.openNewEventDialog({
                    start: "",
                    end: "",
                  })
                )
              }
              disabled={error}
            >
              <Icon>add</Icon>
            </Fab>
			</Tooltip>
          </FuseAnimate>
          <EventDialog
            titleOptions={titleOptions}
            getCalendarEvent={() => searchData()}
            selectedCountry={selectedCountry}
            countryOptions={countryOptions}
			      currentEvents={events}
          />
        </div>
        <HolidaysList holiday={events} loadData={searchData} titleOptions={titleOptions}/>
      </div>
    </>
  );
}

export default withReducer("calendarApp", reducer)(CalendarMain);
